// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';

import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { ToggleProps } from './interfaces';
import InternalToggle from './internal';

export { ToggleProps };

const Toggle = React.forwardRef<ToggleProps.Ref, ToggleProps>((props, ref) => {
  const baseComponentProps = useBaseComponent('Toggle', { props: { readOnly: props.readOnly } });
  return <InternalToggle {...props} {...baseComponentProps} ref={ref} __injectAnalyticsComponentMetadata={true} />;
});

applyDisplayName(Toggle, 'Toggle');
export default Toggle;



// WEBPACK FOOTER //
// /local/home/vibhorbh/workplace/Phoenix/src/toggle/index.tsx